module.exports = __webpack_public_path__ + "img/Group 10@2x.fea8a1df.png";